<template>
  <div
    :class="[
      cell.isAnswer ? 'column' : 'containerAnswer',
      isInFirstRow && 'isInFirstRow',
      'p-0',
    ]"
    :data-positiony="cell.positiony"
    :data-positionx="cell.positionx"
  >
    <div
      v-if="cell.isAnswer"
      class="d-flex flex-column p-0 w-100 h-100"
    >
      <div class="symbol" :style="'font-family:' + font" v-if="!locked && font">
        {{ cell.text }}
      </div>
      <div
        :class="[
          ' printElement bg-white',
          { backgroundLocked: locked },
        ]"
      >
        <p>{{ cell.text }}</p>
      </div>
    </div>
    <div
      v-else
      :class="[
        'd-flex align-items-center w-100',
        isInFirstRow && 'isInFirstRow',
      ]"
    >
      <div class="h-100 d-flex flex-grow-1">
        <div class="w-100 h-100 question text-center  px-2 py-3">
          <span>{{ cell.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cryptogram-cell',
  props: {
    cell: {
      type: Object,
      require: true,
    },
    font: {
      type: String,
      require: true,
    },
  },
  computed: {
    isInFirstRow() {
      return this.cell.positionx === '0';
    },
    locked() {
      return this.cell.settings.locked;
    },
  },
  data() {
    return {
      words: [],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/cryptogram';
p {
  margin: 0;
  font-weight: bold;
  font-size: 24px;
}

.containerAnswer {
  display: flex;
}

.symbol {
  width: 100%;
  height: 35%;
  text-align: center;
  font-size: 18px;
  line-height: 16px;
  margin-top: 8px;
  color: #444;
}

.printElement {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}

.backgroundLocked {
  background-color: $gray !important;
}

.question {
  border: 0;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  width: 100%;
  height: 100%;
  line-height: 1;
  color: black;
}

</style>
